const firstPresent = (...values) => values.find((value) => value !== undefined && value !== null && value !== "");

const positiveIntegerOrNull = (value) => {
  const number = Number(value);
  return Number.isInteger(number) && number > 0 ? number : null;
};

export const normalizeProductionBatchFields = (card = {}) => {
  const batchGroupId = firstPresent(
    card.batchGroupId,
    card.batch_group_id,
    card.batchgroupid
  );
  const batchIndex = positiveIntegerOrNull(
    firstPresent(card.batchIndex, card.batch_index, card.batchindex)
  );
  const batchTotal = positiveIntegerOrNull(
    firstPresent(card.batchTotal, card.batch_total, card.batchtotal)
  );
  const hasBatch = Boolean(batchGroupId && batchIndex && batchTotal);

  return {
    ...card,
    batchGroupId: batchGroupId ? String(batchGroupId) : null,
    batchIndex: hasBatch ? batchIndex : null,
    batchTotal: hasBatch ? batchTotal : null,
    batchLabel: hasBatch ? `${batchIndex}/${batchTotal}` : null,
  };
};

export const getProductionBatchGroupId = (card = {}) =>
  normalizeProductionBatchFields(card).batchGroupId;

const sameKnownValue = (leftValue, rightValue) => {
  if (leftValue === undefined || leftValue === null || leftValue === "") return true;
  if (rightValue === undefined || rightValue === null || rightValue === "") return true;
  return String(leftValue) === String(rightValue);
};

export const areCompatibleProductionBatchCards = (left = {}, right = {}) =>
  sameKnownValue(
    left.departmentId || left.department_id,
    right.departmentId || right.department_id
  ) &&
  sameKnownValue(
    left.stepNumberMajor || left.seq,
    right.stepNumberMajor || right.seq
  );
